import type { GetSignInDto, GetSignInResponse } from '@/domains/auth/api/login';
import type { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';

import { fetchSignIn } from '@/domains/auth/api/login';

export type UseSignInParams = {
  onSuccess?: () => void;
};

export function useSignInMutation({ onSuccess }: UseSignInParams) {
  const mutation = useMutation<GetSignInResponse, AxiosError, GetSignInDto>({
    mutationFn: fetchSignIn,
    onSuccess,
  });

  return {
    isLoading: mutation.isLoading,
    errorCode: mutation.error?.response ? mutation.error.response.status : null,
    signIn: mutation.mutate,
  };
}
